import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { AffiliateDAO } from './dao/affiliateDAO';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AffiliateBannerConfig } from 'anchor-shared/lib/model/entity/affiliate';
import { isPlatformBrowser } from '@angular/common';
import { UserDAO } from './dao/userDAO';
import * as moment from 'moment';

@Injectable()
export class AffiliateStatusService {
  currentValidVanity = new BehaviorSubject<AffiliateBannerConfig>(null);
  isBrowser = false;
  localStorageKey = 'affiliate-banner-config';

  constructor(
    private readonly affiliateDAO: AffiliateDAO,
    private readonly userDAO: UserDAO,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  setAffiliate(potentialVanity: string): void {
    const user = this.userDAO.getCurrentUser();
    if (!user || this.userDAO.currentUserIs('Customer')) {
      this.affiliateDAO
        .checkValidity(potentialVanity)
        .subscribe((validatedConfig) => {
          if (validatedConfig && validatedConfig.id) {
            this.setLocalStorage(validatedConfig);
            this.currentValidVanity.next(validatedConfig);
          }
        });
    } else {
      console.log('declining to set affiliate based on role');
    }
  }

  isValid(): boolean {
    return !!this.currentValidVanity.value;
  }

  checkCurrentBannerConfig(): void {
    if (this.isBrowser) {
      const retrievedObject = localStorage.getItem(this.localStorageKey);
      if (retrievedObject && retrievedObject.length) {
        const config: BrowserAffiliateConfig = JSON.parse(retrievedObject);
        if (
          config &&
          config.id &&
          moment() < moment(config.expiry, BrowserBannerConfigDateFormat)
        ) {
          this.currentValidVanity.next(config);
          this.setAffiliate(config.vanity);
        }
      } else {
        this.currentValidVanity.next(null);
      }
    }
  }

  clearFromStorage(): void {
    if (this.isBrowser) {
      localStorage.removeItem(this.localStorageKey);
      this.currentValidVanity.next(null);
    }
  }

  private setLocalStorage(bannerConfig: AffiliateBannerConfig): void {
    if (this.isBrowser) {
      const bannerStorage: any = bannerConfig;
      bannerStorage.expiry = moment()
        .add(6, 'months')
        .format(BrowserBannerConfigDateFormat);
      window.localStorage.setItem(
        this.localStorageKey,
        JSON.stringify(bannerConfig),
      );
    }
  }
}

const BrowserBannerConfigDateFormat = 'YYYY-MM-DD';

export interface BrowserAffiliateConfig extends AffiliateBannerConfig {
  // 2023-02-16T02:01:45.791Z
  expiry: string;
}
